export default class DateWithoutTime {

  value: Date | null;

  constructor (value: string | Date | null) {
    if (value == null) {
      this.value = value;
    } else if (typeof value === "string") {
      this.value = new Date(value);
    } else {
      this.value = value;
    }
  }

  getDate(): Date | null {
    return this.value;
  }

  getValue4Display(): string {
    return this.convertString("/");
  }

  getValue4Server(): string {
    return this.convertString("-");
  }

  equals(target: DateWithoutTime): boolean {
    return this.getValue4Display() === target.getValue4Display()
  }

  isInvalid(): boolean {
    if (!this.value) {
      return true;
    }
    return Number.isNaN(this.value.getTime());
  }
  
  private convertString(delimiter: string) {
    if (!this.value) {
      return "";
    }
    return `${this.value.getFullYear()}${delimiter}${(this.value.getMonth() + 1).toString().padStart(2, '0')}${delimiter}${this.value.getDate().toString().padStart(2, '0')}`;
  }

  static now(): DateWithoutTime {
    return new DateWithoutTime(new Date());
  }

  static sortAsc(a:DateWithoutTime, b: DateWithoutTime) {
    if (a.getValue4Display() < b.getValue4Display()) {
      return -1;
    } else if (a.getValue4Display() > b.getValue4Display()) {
      return 1;
    } else {
      return 0;
    }
  }
}
